import styled, { CSSObject } from 'styled-components';

export const TabsHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  background: white;
  padding-top: 20px;
`;

export const TabsContainer = styled.div`
  display: flex;
  margin-top: 20px;
`;

interface TabPanelContainerProps {
  customStyle?: CSSObject;
}

export const TabsPanelsContainer = styled.div<TabPanelContainerProps>`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  margin-top: 20px;
`;

interface TabPanelProps {
  active: boolean;
}

export const TabPanel = styled.div<TabPanelProps>`
  width: 100%;
  display: ${(props) => (props.active ? 'block' : 'none')};
  margin-right: -100%;
  background: white;
  border-radius: 8px;
  padding: 20px;
`;
